import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_CLIENTE } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDolClienteState extends EntityState<IID_OL_CLIENTE, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_CLIENTE })
export class IIDolClienteStore extends EntityStore<IIDolClienteState> {
  constructor() {
    super([]);
  }
}
